import React, { useState } from "react";
// import "../../assets/css/globalSettings.css"; // Assuming you have the CSS file

import CloseIcon from "../../assets/icons/close.svg";

const GlobalSettings = () => {
  const [showPopup, setShowPopup] = useState(false);

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  return (
    <div>
      <div className="container mt-3">
        <div className="row g-5 mb-5 ">
          <div className="col">
            <div className="global-settings-card">
              <div className="d-flex justify-content-between align-content-center global-settings-card-header">
                <h6>General Entry</h6>
                <div>
                  <div id="overlay"></div>
                  <button
                    type="button"
                    id="opengeneralEntryPopup"
                    onClick={togglePopup}
                  >
                    Edit
                  </button>
                </div>
              </div>
              <div className="global-settings-card-body">
                <div className="d-flex justify-content-between align-content-center">
                  <div className="d-flex align-content-center gap-2">
                    <img
                      src="assets/icons/serviceCall.svg"
                      width="18px"
                      height="18px"
                      alt="Service Call Icon"
                    />
                    <p className="small-body">Client Name</p>
                  </div>
                  <p className="medium-body">Titan</p>
                </div>
                <div className="d-flex justify-content-between align-content-center">
                  <div className="d-flex align-content-center gap-2">
                    <img
                      src="assets/icons/serviceCall.svg"
                      width="18px"
                      height="18px"
                      alt="Service Call Icon"
                    />
                    <p className="small-body">Cluster</p>
                  </div>
                  <p className="medium-body">South East Europe</p>
                </div>
                <div className="d-flex justify-content-between align-content-center">
                  <div className="d-flex align-content-center gap-2">
                    <img
                      src="assets/icons/serviceCall.svg"
                      width="18px"
                      height="18px"
                      alt="Service Call Icon"
                    />
                    <p className="small-body">Plant</p>
                  </div>
                  <p className="medium-body">Titan Cementarnica Sharrem</p>
                </div>
                <div className="d-flex justify-content-between align-content-center">
                  <div className="d-flex align-content-center gap-2">
                    <img
                      src="assets/icons/serviceCall.svg"
                      width="18px"
                      height="18px"
                      alt="Service Call Icon"
                    />
                    <p className="small-body">matric</p>
                  </div>
                  <p className="medium-body">PVl</p>
                </div>

                <div className="d-flex justify-content-between align-content-center">
                  <div className="d-flex align-content-center gap-2">
                    <img
                      src="assets/icons/serviceCall.svg"
                      width="18px"
                      height="18px"
                      alt="Service Call Icon"
                    />
                    <p className="small-body">Financial Month</p>
                  </div>
                  <p className="medium-body">01</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="global-settings-card">
              <div className="d-flex justify-content-between align-content-center global-settings-card-header">
                <h6>Data Related</h6>
                <button type="button" id="datarelatedpopup">
                  Edit
                </button>
              </div>
              <div className="global-settings-card-body">
                <div className="d-flex justify-content-between align-content-center">
                  <div className="d-flex gap-2">
                    <img
                      src="assets/icons/analytic.svg"
                      width="18px"
                      height="18px"
                      alt="img"
                    />
                    <p className="small-body">Data Resources</p>
                  </div>
                  <p className="medium-body">Titan</p>
                </div>
                <div className="d-flex justify-content-between align-content-center">
                  <div className="d-flex gap-2">
                    <img
                      src="assets/icons/exchange.svg"
                      width="18px"
                      height="18px"
                      alt="img"
                    />
                    <p className="small-body">Data Source Path</p>
                  </div>
                  <p className="medium-body">South East Europe</p>
                </div>
                <div className="d-flex justify-content-between align-content-center">
                  <div className="d-flex gap-2">
                    <img
                      src="assets/icons/identitycard.svg"
                      width="18px"
                      height="18px"
                      alt="img"
                    />
                    <p className="small-body">DSC</p>
                  </div>
                  <p className="medium-body">Titan Cementarnica Sharrem</p>
                </div>
                <div className="d-flex justify-content-between align-content-center">
                  <div className="d-flex gap-2">
                    <img
                      src="assets/icons/pause.svg"
                      width="18px"
                      height="18px"
                      alt="img"
                    />
                    <p className="small-body">Sampling Interval</p>
                  </div>
                  <p className="medium-body">PVl</p>
                </div>
                <div className="d-flex justify-content-between align-content-center">
                  <div className="d-flex gap-2">
                    <img
                      src="assets/icons/calender.svg"
                      width="18px"
                      height="18px"
                      alt="img"
                    />
                    <p className="small-body">Date Time Format</p>
                  </div>
                  <p className="medium-body">01</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row g-5 mb-5">
          <div className="col">
            <div className="global-settings-card">
              <div className="d-flex justify-content-between align-content-center global-settings-card-header">
                <h6>Assessment Related</h6>
                <button type="button" id="assessmentpopup">
                  Edit
                </button>
              </div>
              <div className="global-settings-card-body">
                <div className="d-flex justify-content-between align-content-center">
                  <div className="d-flex  align-content-center gap-2">
                    <img
                      src="assets/icons/correct.svg"
                      width="18px"
                      height="18px"
                      alt="img"
                    />
                    <p className="small-body">Data Length</p>
                  </div>
                  <p className="medium-body">120min</p>
                </div>
                <div className="d-flex justify-content-between align-content-center">
                  <div className="d-flex  align-content-center gap-2">
                    <img
                      src="assets/icons/pulse.svg"
                      width="18px"
                      height="18px"
                      alt="img"
                    />
                    <p className="small-body">Auto Run Frequency</p>
                  </div>
                  <p className="medium-body">30min</p>
                </div>
                <div className="d-flex justify-content-between align-content-center">
                  <div className="d-flex  align-content-center gap-2">
                    <img
                      src="assets/icons/countdown.svg"
                      width="18px"
                      height="18px"
                      alt="img"
                    />
                    <p className="small-body">Time From</p>
                  </div>
                  <p className="medium-body">00:00:00</p>
                </div>
                <div className="d-flex justify-content-between align-content-center">
                  <div className="d-flex  align-content-center gap-2">
                    <img
                      src="assets/icons/countdown.svg"
                      width="18px"
                      height="18px"
                      alt="img"
                    />
                    <p className="small-body">Time To</p>
                  </div>
                  <p className="medium-body">00:00:00</p>
                </div>
                <div className="d-flex justify-content-between align-content-center">
                  <div className="d-flex  align-content-center gap-2">
                    <img
                      src="assets/icons/risk.svg"
                      width="18px"
                      height="18px"
                      alt="img"
                    />
                    <p className="small-body">Model Severity</p>
                  </div>
                  <p className="medium-body">Medium</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="global-settings-card">
              <div className="d-flex justify-content-between align-content-center global-settings-card-header">
                <h6>Alarams Related</h6>
                <button type="button" id="alaramspopup">
                  Edit
                </button>
              </div>
              <div className="global-settings-card-body">
                <div className="d-flex justify-content-between align-content-center">
                  <div className="d-flex gap-2">
                    <img
                      src="assets/icons/alarmclock.svg"
                      width="18px"
                      height="18px"
                      alt="img"
                    />
                    <p className="small-body">Aleram Status</p>
                  </div>
                  <p className="medium-body">Off</p>
                </div>
                <div className="d-flex justify-content-between align-content-center">
                  <div className="d-flex gap-2">
                    <img
                      src="assets/icons/success.svg"
                      width="18px"
                      height="18px"
                      alt="img"
                    />
                    <p className="small-body">Auto Send Email</p>
                  </div>
                  <p className="medium-body">Off</p>
                </div>
                <div className="d-flex justify-content-between align-content-center">
                  <div className="d-flex gap-2">
                    <img
                      src="assets/icons/bell.svg"
                      width="18px"
                      height="18px"
                      alt="img"
                    />
                    <p className="small-body">Alerts To</p>
                  </div>
                  <p className="medium-body">info@akxtech.com</p>
                </div>
                <div className="d-flex justify-content-between align-content-center">
                  <div className="d-flex gap-2">
                    <img
                      src="assets/icons/email.svg"
                      width="18px"
                      height="18px"
                      alt="img"
                    />
                    <p className="small-body">Auto Email Send Time</p>
                  </div>
                  <p className="medium-body">00:00:00</p>
                </div>
                <div className="d-flex justify-content-between align-content-center">
                  <div className="d-flex gap-2">
                    <img
                      src="assets/icons/risk.svg"
                      width="18px"
                      height="18px"
                      alt="img"
                    />
                    <p className="small-body">Model Severity</p>
                  </div>
                  <p className="medium-body">Medium</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row g-5 mb-5">
          <div className="col">
            <div className="global-settings-card">
              <div className="d-flex justify-content-between align-content-center global-settings-card-header">
                <h6>PVI Modal Related</h6>
                <button type="button" id="pvipopup">
                  Edit
                </button>
              </div>
              <div className="global-settings-card-body">
                <div className="d-flex justify-content-between align-content-center">
                  <div className="d-flex  align-content-center gap-2">
                    <img
                      src="assets/icons/serviceCall.svg"
                      width="18px"
                      height="18px"
                      alt="img"

                    />
                    <p className="small-body">Data Length</p>
                  </div>
                  <p className="medium-body">120min</p>
                </div>
                <div className="d-flex justify-content-between align-content-center">
                  <div className="d-flex  align-content-center gap-2">
                    <img
                      src="assets/icons/open-1.svg"
                      width="18px"
                      height="18px"
                      alt="img"
                    />
                    <p className="small-body">Auto Run Frequency</p>
                  </div>
                  <p className="medium-body">30min</p>
                </div>
                <div className="d-flex justify-content-between align-content-center">
                  <div className="d-flex  align-content-center gap-2">
                    <img
                      src="assets/icons/nuclear-energy.svg"
                      width="18px"
                      height="18px"
                      alt="img"
                    />
                    <p className="small-body">Time From</p>
                  </div>
                  <p className="medium-body">00:00:00</p>
                </div>
                <div className="d-flex justify-content-between align-content-center">
                  <div className="d-flex  align-content-center gap-2">
                    <img
                      src="assets/icons/idCard.svg"
                      width="18px"
                      height="18px"
                      alt="img"
                    />
                    <p className="small-body">Time To</p>
                  </div>
                  <p className="medium-body">00:00:00</p>
                </div>
                <div className="d-flex justify-content-between align-content-center">
                  <div className="d-flex  align-content-center gap-2">
                    <img
                      src="assets/icons/finance.svg"
                      width="18px"
                      height="18px"
                      alt="img"
                    />
                    <p className="small-body">Model Severity</p>
                  </div>
                  <p className="medium-body">Medium</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="global-settings-card">
              <div className="d-flex justify-content-between align-content-center global-settings-card-header">
                <h6>House Keeping</h6>
                <button type="button" id="housepopup">
                  Edit
                </button>
              </div>
              <div className="global-settings-card-body">
                <div className="d-flex justify-content-between align-content-center">
                  <div className="d-flex gap-2">
                    <img
                      src="assets/icons/deleted.svg"
                      width="18px"
                      height="18px"
                      alt="img"

                    />
                    <p className="small-body">Clear Raw Data</p>
                  </div>
                  <p className="medium-body">Off</p>
                </div>
                <div className="d-flex justify-content-between align-content-center">
                  <div className="d-flex gap-2">
                    <img
                      src="assets/icons/group.svg"
                      width="18px"
                      height="18px"
                      alt="img"

                    />
                    <p className="small-body">Older than</p>
                  </div>
                  <p className="medium-body">30 days</p>
                </div>
                <div className="d-flex justify-content-between align-content-center">
                  <div className="d-flex gap-2">
                    <img
                      src="assets/icons/clock.svg"
                      width="18px"
                      height="18px"
                      alt="img"

                    />
                    <p className="small-body">Everyday at</p>
                  </div>
                  <p className="medium-body">12:00:00 hrs</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Edit Popup */}
        {showPopup && (
          <div id="popup" className="global-settings-card-popup">
            <div className="global-settings-card-header d-flex justify-content-between">
              <h5>Edit General Entry</h5>
              <img
                src={CloseIcon}
                onClick={closePopup}
                width="28px"
                height="28px"
                alt="Close Icon"
              />
            </div>
            <form>
              <div className="edit-settings-form">
                <div className="row mb-4">
                  <div className="col-md-6 col-sm-12">
                    <div className="d-flex  align-content-center gap-2">
                      <img
                        src="assets/icons/serviceCall.svg"
                        width="18px"
                        height="18px"
                        alt="img"
                      />
                      <p className="small-body">Client Name</p>
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <input placeholder="Enter client name" />
                  </div>
                </div>
                <div className="row mb-4">
                  <div className="col-md-6 col-sm-12">
                    <div className="d-flex  align-content-center gap-2">
                      <img
                        src="assets/icons/open-1.svg"
                        width="18px"
                        height="18px"
                        alt="img"
                      />
                      <p className="small-body">Cluster</p>
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <input placeholder="Enter cluster" />
                  </div>
                </div>
                <div className="row mb-4">
                  <div className="col-md-6 col-sm-12">
                    <div className="d-flex  align-content-center gap-2">
                      <img
                        src="assets/icons/nuclear-energy.svg"
                        width="18px"
                        height="18px"
                        alt="img"
                      />
                      <p className="small-body">Plant</p>
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <input placeholder="Enter Plant" />
                  </div>
                </div>
                <div className="row mb-4">
                  <div className="col-md-6 col-sm-12">
                    <div className="d-flex  align-content-center gap-2">
                      <img
                        src="assets/icons/idCard.svg"
                        width="18px"
                        height="18px"
                        alt="img"
                      />
                      <p className="small-body">Matric</p>
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <input placeholder="Enter matric" />
                  </div>
                </div>
                <div className="row ">
                  <div className="col-md-6 col-sm-12">
                    <div className="d-flex  align-content-center gap-2">
                      <img
                        src="assets/icons/finance.svg"
                        width="18px"
                        height="18px"
                        alt="img"
                      />
                      <p className="small-body">Financial Month</p>
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <input placeholder="Choose month" />
                  </div>
                </div>
              </div>
              <div className="global-settings-edit-card-footer">
                <button
                  className="global-settings-edit-card-disbtn"
                  id="discard-edit"
                  onClick={closePopup}
                >
                  DISCARD
                </button>
                <button className="global-settings-edit-card-upbtn">
                  UPDATE
                </button>
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default GlobalSettings;
